import { render, staticRenderFns } from "./CommunityContents.vue?vue&type=template&id=b79b4512&scoped=true&"
import script from "./CommunityContents.vue?vue&type=script&lang=ts&"
export * from "./CommunityContents.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityContents.vue?vue&type=style&index=0&id=b79b4512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79b4512",
  null
  
)

export default component.exports